module.exports = __webpack_public_path__ + "assets/img/20210927-1.ca8ce70a.png";